import { render, staticRenderFns } from "./btn-recruit.vue?vue&type=template&id=287cef98&"
import script from "./btn-recruit.vue?vue&type=script&lang=js&"
export * from "./btn-recruit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports